module.exports = __webpack_public_path__ + "static/media/SHARMBLE-LOGO-40x40.d04ece45.svg";